module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-posthog/gatsby-browser.js'),
      options: {"plugins":[],"apiKey":"phc_b9vWRfKQcy2vkrzP0FbkNZCVVzTeHLWngoAe74vTpoo","apiHost":"https://app.posthog.com","head":true,"isEnabledDevMode":true,"initOptions":{}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
